import ECViewState from 'mini-mail-bootstrap/lib/routing/viewStateHandler';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import setMailListFocusInfo from 'mini-mail-list-store/lib/actions/setMailListFocusInfo';
import { action } from 'satcheljs/lib/legacy';
import { ActionMessage } from 'satcheljs';
import { ECLoadedStateOrchestrator } from 'mini-email-context/lib/orchestrator/ECLoadedStateOrchestrator';
import { getItemIdToExpandForSearch } from 'mini-mail-list-store/lib/utils/getItemIdToExpandForSearch';
import { getListViewTypeCustomData } from 'mini-mail-list-store/lib/selectors/getListViewTypeCustomData';
import { getStore } from 'owa-mail-store/lib/store/Store';
import { getSubject } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { hideExtendedLoadingScreen } from 'mini-email-context/lib/handleLoadingExtension';
import { lazyPrefetchAdjacentItemsOnDelay } from 'mini-mail-prefetch';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import {
    lazyLoadConversationReadingPane,
    lazyLoadItemReadingPane,
} from 'mini-mail-reading-pane-loader';

export default action('singleSelectMailItem', {
    datapoint: {
        name: 'LoadMailConversation' /* loadMailConversationDatapoint */,
        options: { isCore: true },
    },
})(async function singleSelectMailItem(
    rowId: string,
    itemId?: string,
    inputRowSubject?: string
): Promise<void | ActionMessage> {
    const mailStore = getStore();
    const tableView = getSelectedTableView();
    const rowSubject = inputRowSubject || getSubject(rowId);

    mailStore.mailModule.selectedId = rowId;
    mailStore.mailModule.selectedSubject = rowSubject;

    // Set this item as the current focused row in the mail list so that
    // when we come back to list view, focus directly goes to this item
    setMailListFocusInfo(tableView, {
        focusedRowId: rowId,
    });

    addCustomPropertiesInDataPoint();

    // lazy load the data for adjacent rows for improved reading pane load
    lazyPrefetchAdjacentItemsOnDelay.importAndExecute(rowId, tableView);

    // lazy load reading pane
    if (ECViewState.shouldItemViewBeShown()) {
        await lazyLoadItemReadingPane.importAndExecute(rowId, false /* shouldLogDataPoint */);
    } else {
        // Get conversation node to expand in case of search
        let initiallySelectedItemId = getItemIdToExpandForSearch(rowId) || null;
        // Handling the case when it is not search
        if (initiallySelectedItemId == null) {
            initiallySelectedItemId = !!itemId ? itemId : null;
        }
        await lazyLoadConversationReadingPane.importAndExecute(
            rowId,
            initiallySelectedItemId,
            itemId
        );
    }

    ECLoadedStateOrchestrator(true);

    //Once EC is loaded, hide the loading screen. This is needed as by the time this code is hit in an EC path, the function call in postMailBootstrap would have already been run.
    hideExtendedLoadingScreen();
});

const addCustomPropertiesInDataPoint = () => {
    const tableView = getSelectedTableView();

    // Add the folder name as custom data
    const datapoint = returnTopExecutingActionDatapoint();
    const folderName =
        tableView &&
        tableView.tableQuery &&
        tableView.tableQuery.folderId &&
        folderIdToName(tableView.tableQuery.folderId);

    datapoint.addCustomData({
        Folder: !folderName || folderName === 'none' ? 'CustomFolder' : folderName,
        ...getListViewTypeCustomData(),
    });
};
